import Login from '../../pages/login'

const loginRoute = [
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

export default loginRoute



// WEBPACK FOOTER //
// ./src/router/login/index.js